export function getScrollParent(element: HTMLElement | null): HTMLElement {
  if (element == null) {
    return window.document.documentElement;
  }

  if (window.getComputedStyle(element).overflow !== 'visible') {
    return element;
  } else {
    return getScrollParent(element.parentElement);
  }
}

export function getScrollOffset(element: HTMLElement, scrollParent: HTMLElement | null = null): {left: number; top: number; right: number; bottom: number} {
  if (scrollParent === null) {
    scrollParent = getScrollParent(element);
  }

  const elementRect = element.getBoundingClientRect();
  const scrollParentRect = scrollParent.getBoundingClientRect();

  return {
    left: elementRect.left - scrollParentRect.left,
    top: elementRect.top - scrollParentRect.top,
    right: scrollParentRect.right - elementRect.right,
    bottom: scrollParentRect.bottom - elementRect.bottom,
  };
}

/**
 * Chromium does not do two smooth scrollings at the same time with the native scrollIntoView function
 */
export function scrollToElement(
  element: HTMLElement,
  options: {
    axis?: 'x' | 'y' | 'both';
    behavior?: ScrollBehavior;
    scrollParent?: HTMLElement;
  } = {},
): void {
  options.scrollParent = options.scrollParent ?? getScrollParent(element);
  options.behavior = options.behavior ?? 'smooth';
  options.axis = options.axis ?? 'both';

  const scrollOffset = getScrollOffset(element, options.scrollParent);

  const scrollTo: {
    left?: number;
    top?: number;
  } = {};
  if (options.axis === 'x' || options.axis === 'both') {
    if (scrollOffset.left < 0 || scrollOffset.right < 0) {
      scrollTo.left = options.scrollParent.scrollLeft + Math.min(scrollOffset.left, 0) - Math.min(scrollOffset.right, 0);
    }
  }
  if (options.axis === 'y' || options.axis === 'both') {
    if (scrollOffset.bottom < 0 || scrollOffset.top < 0) {
      scrollTo.top = options.scrollParent.scrollTop + Math.min(scrollOffset.top, 0) - Math.min(scrollOffset.bottom, 0);
    }
  }

  if (scrollTo.left !== undefined || scrollTo.top !== undefined) {
    options.scrollParent.scrollTo({
      ...scrollTo,
      behavior: options.behavior,
    });
  }
}
